import { LocalizedDateFromUtc, SpacedDash } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

interface TimeUnitIntervalsProps {
    timeUnitIntervals: Array<{
        firstTimeUnitStartUtc: string;
        lastTimeUnitStartUtc: string;
    }>;
}

export const TimeUnitIntervals = ({ timeUnitIntervals }: TimeUnitIntervalsProps) => (
    <Stack vertical>
        {timeUnitIntervals.map(({ firstTimeUnitStartUtc, lastTimeUnitStartUtc }) => (
            <span key={`${firstTimeUnitStartUtc}-${lastTimeUnitStartUtc}`}>
                <LocalizedDateFromUtc utcString={firstTimeUnitStartUtc} />
                {SpacedDash}
                <LocalizedDateFromUtc utcString={lastTimeUnitStartUtc} />
            </span>
        ))}
    </Stack>
);
